import React, {Component} from 'react';

class Preview extends Component {

    render() {
        if (this.props.entry.fields.Photo
            && this.props.entry.fields.Photo.length > 0) {

            return (
                <div className="Card-Photo">
                    <div style={{backgroundImage: 'url("'+(this.props.entry.fields.Photo[0].thumbnails.large.url)+'")'}}/>
                </div>
            );
        }

        return <div/>;
    }
}

export default Preview;


// WEBPACK FOOTER //
// ./src/Components/Cards/Photo.js